import React, { useEffect, useState } from "react";
import Buttons from "../../../../library/custom/button/Button";
import { FormControl, FormControlLabel, FormGroup, Grid } from "@mui/material";
import {
  ISwitch,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
} from "../../../../constant/constant";
import { TableLoader } from "../../../../library/common/Loader";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import NORow from "../../../../library/custom/noRow/noRow";
import SearchIcon from "@mui/icons-material/Search";
import * as jhaAction from "../../../../redux/actions/jhaAction";
import { useDispatch } from "react-redux";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import ReportRowManipulte from "../../shared/ReportRowManipulate";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { InactiveClient } from "../../../../utils/helper";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import {
  ADMIN_JHA_LIST_TEMPLATE,
  ADMIN_JHA_ADD_TEMPLATE,
} from "../../../../constant/routeContant";
import { useDebounce } from "../../../../utils/useDebounceSearch";

const JhaListTemplate = ({
  addTemplate,
  isLoading,
  templateList,
  itemsCount,
  getTemplateListData,
  handleStatusChange,
  handleEditOnClick,
  templateListDatas,
}) => {
  const dataBack = {
    title: "Back to Hazard Analysis Configuration",
    route: -1,
  };

  const dispatch = useDispatch();

  const handleChange = (templateSetItem) => {
    if (InactiveClient()) return;
    const newCatList = [...templateList];
    newCatList.forEach((lists) => {
      if (lists.id === templateSetItem.id) {
        lists.isGlobal = false;
        lists.hazardsId = lists.id;
        lists.isActive = !lists.isActive;
        lists.listsmodifiedBy = parseInt(USER_ID());
      }
    });
    handleStatusChange(templateSetItem);
  };

  const columns = [
    {
      field: "templateName",
      headerName: "Hazard Analysis Templates",
      flex: 1.9,
    },
    { field: "dateOfEntry", headerName: "Date of Entry", flex: 1 },
    { field: "assetType", headerName: "Asset Type", flex: 1 },
    { field: "createdBy", headerName: "Created by", flex: 1 },
    {
      flex: 1,
      field: "isActive",
      headerName: "Status",
      renderCell: (rows) => (
        <Grid className="catListBox">
          <Grid className="closeIcon">
            <FormControl component="fieldset" variant="standard">
              <FormGroup className="isActiveBox">
                {checkPrivileges([58, 12]) && (
                  <FormControlLabel
                    control={
                      <ISwitch
                        checked={
                          rows?.row.isActive ? rows?.row.isActive : false
                        }
                        onChange={() => handleChange(rows?.row)}
                        name="status"
                      />
                    }
                  />
                )}
                <div>{rows?.row?.isActive ? "Active" : "Inactive"}</div>
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      ),
    },
    {
      flex: 0.6,
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={[]}
          fileNameXL={"Categories List"}
        />
      ),
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            editOnClick={() => {
              handleEditOnClick(rows.row);
            }}
            edit={checkPrivileges([58, 59, 12])}
            editLabel="Edit Template"
          />
        );
      },
    },
  ];

  const [search, setsearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setpage] = useState(0);
  const [filterObjRestored, setFilterObjRestored] = useState(false);

  useEffect(() => {
    const allowedRoutePrefixes = [
      ADMIN_JHA_LIST_TEMPLATE,
      ADMIN_JHA_ADD_TEMPLATE,
    ];
    const previousRoute = getPreviousRoute();
    const isFromPreserveRoute =
      previousRoute &&
      allowedRoutePrefixes.some((prefix) => previousRoute.startsWith(prefix)) &&
      sessionStorage.getItem("jhaTemplateListPreserveState") === "true";
    sessionStorage.removeItem("jhaTemplateListPreserveState");

    if (isFromPreserveRoute && templateListDatas?.filterObj) {
      const {
        search: savedSearch = "",
        page: savedPage = 1,
        pageSize: savedPageSize = PAGE_SIZE,
      } = templateListDatas.filterObj;

      setsearch(savedSearch);
      setpage(savedPage > 0 ? savedPage - 1 : 0);
      setPageSize(savedPageSize);
    } else {
      setsearch("");
      setpage(0);
      setPageSize(PAGE_SIZE);
    }
    setFilterObjRestored(true);
  }, []);

  useEffect(() => {
    if (!filterObjRestored) return;
    getTemplateListData({
      page: page + 1,
      pageSize: pageSize,
      search: search,
    });
  }, [filterObjRestored]);

  function handleautoSearch(params) {
    setsearch(params);
    setpage(0);
    // getTemplateListData({
    //   page: 1,
    //   pageSize: pageSize,
    //   search: params,
    // });
  }

  // pagination

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    getTemplateListData({
      page: page + 1,
      pageSize: newPazeSize,
      search: search,
    });
  };

  const handlePagignation = (newPage) => {
    setpage(newPage);
    getTemplateListData({
      page: newPage + 1,
      pageSize: pageSize,
      search: search,
    });
  };

  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getTemplateListData({
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch ? debouncedSearch : "",
    });
  }, [debouncedSearch]);

  return (
    <section className="grid_main_sec">
      <div className="grid_main_header two_grid">
        <div className="grid_heading_style">Hazard Analysis Templates</div>
        <div>
          {checkPrivileges([58, 59, 12]) && (
            <Buttons
              id="btnAddContact"
              label={"Create Template"}
              varientAddIconBlue={true}
              onClick={() => addTemplate()}
            />
          )}
        </div>
      </div>

      <Grid item container md={12} className="CategoriesBox" mt={3}>
        <Grid item md={5} xs={8} mb={3}>
          <div className="searchcaseid">
            <label htmlFor="search">
              <span>
                <SearchIcon />
              </span>
              <div>
                <input
                  id="search"
                  placeholder="Search Hazard Analysis Templates"
                  type="text"
                  value={search}
                  className=""
                  onChange={(e) => handleautoSearch(e.target.value)}
                  autoComplete="off"
                />
              </div>
            </label>
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid container item md={12} xs={12}>
          <Grid item md={12} className="" mt={3}>
            <div className="desc_box row_uniq">
              <div className="table_style_ui">
                <GridTable
                  getRowId={(r) => r.id}
                  rows={templateList ?? []}
                  rowCount={itemsCount ?? 0}
                  columns={columns}
                  loading={isLoading}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <div onClick={() => dispatch(jhaAction.clearJha())}>
        <BackBtn dataBack={dataBack} />
      </div>
    </section>
  );
};

export default JhaListTemplate;
